// extracted by mini-css-extract-plugin
module.exports = {"container":"ClickAndCollectCountdown_container__hz4qy","time":"ClickAndCollectCountdown_time__LbfiB","newTypography":"ClickAndCollectCountdown_newTypography__f5aPO"};